"use client"

import { Text } from "@/elements"
import React, { FC } from "react"
import { ProCheck } from "@/icons/outline/ProCheck"
import { CheckIcon } from "@/icons/solid"

interface Props {
  showFreeTrialTag?: boolean
}

const benefits = ["Apply to unlimited jobs", "Access to full job details", "Boost your portfolio visibility"]

export const Benefits: FC<Props> = ({ showFreeTrialTag }) => {
  return (
    <div className="flex flex-col gap-3">
      {benefits.map((benefit, key) => {
        return (
          <div key={key} className="flex flex-row items-center gap-2">
            <ProCheck />
            <Text>{benefit}</Text>
          </div>
        )
      })}
      {/* {showFreeTrialTag ? (
        <div className="bg-pro-gradient-100 -ml-2 flex w-fit flex-row items-center gap-2 rounded-sm px-2 py-[5px]">
          <CheckIcon className="fill-[#645293]" />
          <Text className="text-[#645293]">$0 today. 7 day free trial</Text>
        </div>
      ) : null} */}
    </div>
  )
}
